import Component from "../../../../lib/component";
import {CollapserConfig} from "../index";

export const CollapserToggleConfig = {
    baseHtmlClass: 'collapser__toggle',
    selector: '.collapser__toggle',
};

export class CollapserToggle extends Component {

    constructor(id_or_element, collapser) {
        super({
            element: id_or_element,
            config: CollapserToggleConfig
        });

        this.collapser = collapser;

        this.element.addEventListener('click', this.handleClick.bind(this));

        this.render()
    }

    handleClick(e) {
        e.preventDefault();
        this.collapser.toggleCollapse();
        this.render();
    }

    isOpen() {
        return !!this.collapser?.isOpen();
    }

    isCollapsable() {
        return !!this.collapser?.isCollapsable();
    }

    render() {
        this.swapHtmlClassStates(this.isCollapsable(), CollapserConfig.collapsableClassModifier, CollapserConfig.uncollapsableClassModifier);
        this.swapHtmlClassStates(this.isOpen(), CollapserConfig.openClassModifier, CollapserConfig.closedClassModifier);
    }


}
